<div class="attachmentItem mat-elevation-z1" [matTooltip]="fileUpload.displayName">

    <mat-icon>{{iconName()}}</mat-icon>
    <h4 style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; margin: 0">{{fileUpload.displayName}}</h4>
    <button *ngIf="usageType === 'display'" fileSaver mat-flat-button [url]="fileUpload.link">
        <mat-icon>download</mat-icon>
        {{'download'|translate:locale.language}}
    </button>
    <button mat-icon-button (click)="remove.emit()" *ngIf="usageType === 'add'">
        <mat-icon>close</mat-icon>
    </button>
</div>